import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_content_standard_path } from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';
import { CorrelatedContent } from './types';

interface UseCorrelatedContentParams {
  enabled: boolean;
  programId: number;
  standardId: number;
}

// Fetches the content correlated to a single standard within the program, grouped
// Unit → Lesson → item. Only runs when the leaf's content panel is open (`enabled`).
export default function useCorrelatedContent({ enabled, programId, standardId }: UseCorrelatedContentParams) {
  return useQuery({
    enabled,
    queryFn: () => axios.get<CorrelatedContent>(
      plato_api_content_standard_path(standardId),
      { params: { program_id: programId } },
    ).then(res => res.data),
    queryKey: [QueryKeys.StandardCorrelations, standardId, programId],
  });
}
